export default {
  get: (key, _default) => {
    try {
      return window[key]||_default;
    } catch (e) {
      console.warn(`Could not find ENV variable: ${key}. You may need to set it`);
      return _default;
    }
  }
};
